
<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { CollapsibleRoot } from '../../collapsible';

  import { accordionStyles } from '../accordion-styles';
  import { useAccordionContext } from '../use-accordion-context';
  import { AccordionItemProvider } from '../use-accordion-item-context';
  import type { AccordionItemProps } from '../accordion.types';

  const { title, children, css: cssProp, ...itemProps }: AccordionItemProps = $props();

  const accordion = useAccordionContext();
  const item = $derived(accordion.api.getItemState({ value: title }));
  const classes = accordionStyles.raw();

  AccordionItemProvider({title})
</script>

<div {...accordion.api.getItemProps({ value: title, ...itemProps })} class={css(classes.item, cssProp)}>
  <CollapsibleRoot open={item.expanded}>
    {@render children()}
  </CollapsibleRoot>
</div>
